import axios from "axios";

import refreshJwtToken from "shared-anpost-components/utils/refreshJwtToken";

const CMS_API_URL = window.cmsAPIBaseUrl;
const CMS_API_KEY = window.cmsAPISubscriptionKey;
const SERVICE_API_URL = window.intAPIBaseUrl;
const SERVICE_API_KEY = window.intAPISubscriptionKey;
const CIAM_BASE_URL = window.ciamBaseUrl;
const CIAM_APPLICATION_CODE = window.ciamApplicationCode;
const CAP_BASE_URL = window.capBaseUrl;
const APP_AFT_TOKEN = window.appMyAccLoginAFToken;
const AUTO_ADDRESS_BASE_URL = window.autoAddressBaseUrl;
const AUTO_ADDRESS_BASE_KEY = window.appMyDeliveriesAFinderKey;
const TRACK_AND_TRACE_API_URL = window.trackAndTraceAPI_EndpointURL;
const TRACK_AND_TRACE_API_KEY = window.trackAndTraceAPI_Key;
const MY_DELIVERIES_BASE_URL = window.appMyDeliveriesAPI;

export const cmsAxiosInstance = axios.create({
    baseURL: CMS_API_URL,
    headers: {
        "Content-Type": "application/json",
        "Ocp-Apim-Subscription-Key": CMS_API_KEY
    }
});

export const serviceAxiosInstance = axios.create({
    baseURL: SERVICE_API_URL,
    headers: {
        "Content-Type": "application/json",
        "Ocp-Apim-Subscription-Key": SERVICE_API_KEY
    }
});

export const ciamAxiosInstance = axios.create({
    baseURL: CIAM_BASE_URL,
    headers: {
        "Content-Type": "application/json",
        "ANP-APPLICATION-CODE": CIAM_APPLICATION_CODE
    }
});

export const capAxiosInstance = axios.create({
    baseURL: CAP_BASE_URL,
    headers: {
        "Content-Type": "application/json",
        "X-RequestVerificationToken": APP_AFT_TOKEN
    }
});

export const autoAddressAxiosInstance = axios.create({
    baseURL: `${AUTO_ADDRESS_BASE_URL}/autocomplete?key=${AUTO_ADDRESS_BASE_KEY}`,
    headers: {
        "Content-Type": "application/json"
    }
});

export const trackAndTraceAxiosInstance = axios.create({
    baseURL: TRACK_AND_TRACE_API_URL,
    headers: {
        "Content-Type": "application/json",
        "Ocp-Apim-Subscription-Key": TRACK_AND_TRACE_API_KEY
    }
});

export const myDeliveriesAxiosInstance = axios.create({
    baseURL: MY_DELIVERIES_BASE_URL,
    headers: {
        "Content-Type": "application/json"
    }
});

const attachRequestInterceptor = axiosInstance => {
    axiosInstance.interceptors.request.use(
        async config => {
            try {
                const JWTToken = await refreshJwtToken();
                const updatedConfig = { ...config };
                updatedConfig.headers.Authorization = `Bearer ${JWTToken}`;
                return updatedConfig;
            } catch (error) {
                return Promise.reject(error);
            }
        },
        error => Promise.reject(error)
    );
};

// Attach request interceptor to all axios instances
[ciamAxiosInstance, capAxiosInstance, myDeliveriesAxiosInstance].forEach(attachRequestInterceptor);
